"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectRouter = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var Types = require("types");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var ProjectHomeActions = require("@caddigital/sok-reducers/lib/actions/project/home");
var CartActions = require("@caddigital/sok-reducers/lib/actions/cart");
var sok_ui_1 = require("@caddigital/sok-ui");
var DistributionView_1 = require("../../views/DistributionView");
var ProjectHomeView_1 = require("../../views/ProjectHomeView");
var ProjectTeamMembersView_1 = require("../../views/ProjectTeamMembersView");
var BriefcaseListView_1 = require("views/BriefcaseListView");
var ShoppingCart_1 = require("components/sidemenus/ShoppingCart");
var CongridView_1 = require("views/CongridView");
var CongridLinkWizard_1 = require("views/CongridLinkWizard");
var VektorioView_1 = require("views/VektorioView");
var avatars_1 = require("components/Avatar/avatars");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var fileListFilter_1 = require("utils/helpers/fileListFilter");
var translate_1 = require("utils/translate");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var FilesRouter_1 = require("../FilesRouter");
var ordersRouter_1 = require("./ordersRouter");
var automaticOrdersRouter_1 = require("./automaticOrdersRouter");
var Tools_1 = require("views/FileListOverview/Tools");
var ViewHeader_1 = require("views/FileListOverview/ViewHeader");
var ListHeader_1 = require("views/FileListOverview/FileList/ListHeader");
var ListRow_1 = require("views/FileListOverview/FileList/ListRow");
var fileUploadModal_1 = require("actions/fileUploadModal");
var aclUtils = require("utils/acl");
var sokoSiteRouter_1 = require("./sokoSiteRouter");
require("./style.scss");
var mapStateToProps = function (state) {
    return {
        currentProject: state.project.currentProject,
        metadata: state.files.metadata,
        user: state.auth.current.user,
        selectedLanguage: (0, translate_1.getLanguage)(),
        location: state.router.location
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    onFetchProject: function (projectId) {
        return dispatch(ProjectHomeActions.fetchProjectByIdRequest(projectId));
    },
    onFetchRoot: function (project, feature) {
        return dispatch(ProjectHomeActions.fetchRootRequest(project));
    },
    onFetchSchema: function (id) {
        return dispatch(FilesActions.fetchSchema(id, {
            includeSubSchemas: 'true'
        }));
    },
    onFetchCart: function (rootId) { return dispatch(CartActions.fetchItems(rootId)); },
    onFetchProjectError: function (error) {
        return dispatch(ProjectHomeActions.fetchProjectByIdFailure(error));
    },
    redirect: function () { return dispatch((0, connected_react_router_1.replace)('/projects')); },
    setFileUploadModalDescription: function (description) {
        return dispatch(fileUploadModal_1.default.setFileUploadModalDescription(description));
    },
    toggleUploadModal: function () { return dispatch(fileUploadModal_1.default.toggleModalStatus()); },
    appendUploadFiles: function (files, location, parent) { return dispatch(fileUploadModal_1.default.setFileUploadFiles(files, location, parent)); },
    clearFileList: function () { return dispatch(FilesActions.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        var projectId = parseInt(this.props.match.params.projectId, 10);
        if (prevProps.match.params.projectId !== this.props.match.params.projectId) {
            this.props.clearFileList();
            if (!isNaN(projectId)) {
                this.props.onFetchProject(projectId);
            }
            else {
                this.props.onFetchProjectError({ type: 'NOT_FOUND' });
            }
        }
        if (this.props.currentProject.status === 'FETCHED' &&
            this.props.currentProject.project !==
                prevProps.currentProject.project) {
            this.props.onFetchRoot(this.props.currentProject.project, 'FILESTAB');
            var fileUploadModalDescription = (0, translation_1.getLocalization)('fileUploadModal/description/project', [this.props.currentProject.project.name]);
            this.props.setFileUploadModalDescription(fileUploadModalDescription);
        }
        if (this.props.currentProject &&
            this.props.currentProject.status === 'FETCHED' &&
            ((prevProps.currentProject.status === 'FETCHED' &&
                this.props.currentProject.project !==
                    prevProps.currentProject.project) ||
                prevProps.currentProject.status !== 'FETCHED')) {
            this.props.onFetchCart(this.props.currentProject.project.rootFolder);
        }
        if ((this.props.metadata.status === 'STANDBY' &&
            this.props.currentProject &&
            this.props.currentProject.root) ||
            (!prevProps.currentProject &&
                this.props.currentProject &&
                this.props.currentProject.root) ||
            (prevProps.currentProject.root !== this.props.currentProject.root &&
                !this.props.location.pathname.includes('/sokosite/worksitediary/') &&
                this.props.currentProject.root)) {
            this.props.onFetchSchema(this.props.currentProject.root.id);
        }
        if (this.props.currentProject.status === 'ERROR' &&
            this.props.currentProject.error &&
            this.props.currentProject.error.type === 'NOT_FOUND') {
            this.props.redirect();
        }
    },
    componentWillUnmount: function () {
        this.props.clearFileList();
    },
    componentWillMount: function () {
        var projectId = parseInt(this.props.match.params.projectId, 10);
        if (!isNaN(projectId)) {
            this.props.onFetchProject(projectId);
        }
        else {
            this.props.onFetchProjectError({ type: 'NOT_FOUND' });
        }
    }
}), recompose_1.pure);
var adminRoutes = function (baseUrl, user, currentProject, perm) {
    var isGranoOrProjectAdmin = !!(perm &
        ~acl.FEATURE_MASK &
        (acl.PROJECT_ADMIN_GRANT |
            acl.LIGHT_ADMIN_GRANT |
            acl.SOKOBID_ADMIN_GRANT)) ||
        user.map(function (u) { return u.level === 'SuperAdminUserGroup' || false; }).getOrElse(false);
    return ((isGranoOrProjectAdmin || currentProject.project.showPartiesTab) && [
        React.createElement(react_router_dom_1.Route, { exact: true, key: 'teammembers', path: baseUrl + "/teammembers", render: function (props) { return (React.createElement(ProjectTeamMembersView_1.default, __assign({}, props, { currentProject: currentProject.project }))); } })
    ]);
};
var FilesBreadCrumb = function (props) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    var baseUrl = "/".concat(selectedLanguage);
    var currentProject = props.currentProject;
    if (!currentProject) {
        return React.createElement("div", null);
    }
    baseUrl = "".concat(baseUrl, "/projects/").concat(currentProject.id);
    var path = props.path.filter(function (x) { return x.id !== currentProject.rootFolder; });
    return (React.createElement(sok_ui_1.BreadCrumb, null,
        props.currentProject && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id) }, props.currentProject.name)),
        React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(currentProject.id, "/files/").concat(currentProject.rootFolder), onClick: function () {
                return props.clearAllColumnFilters && props.clearAllColumnFilters();
            } }, (0, translation_1.getLocalization)('breadcrumb/projectname/files')),
        path.map(function (folder, index) {
            var url = "/".concat(selectedLanguage, "/projects/").concat(currentProject.id, "/files/").concat(folder.id);
            return (React.createElement(react_router_dom_1.Link, { className: 'sok-breadcrumb-link', key: "".concat(index, "-").concat(folder.id), to: url }, folder.name));
        }),
        props.searchResultsToggled && (React.createElement("span", { className: 'sok-breadcrumb-link', onClick: function () {
                return props.navigateTo &&
                    props.navigateTo("/".concat(selectedLanguage, "/projects/").concat(currentProject.id, "/files/").concat(path[path.length - 1].id), true);
            } }, (0, translation_1.getLocalization)('breadcrumb/projectname/searchResults').toLocaleLowerCase())),
        props.filtering !== 'NONE' && (React.createElement("span", null, (0, fileListFilter_1.getFiltering)(props.filtering))),
        props.children));
};
exports.ProjectRouter = enhance(/** @class */ (function (_super) {
    __extends(ProjectRouterComponent, _super);
    function ProjectRouterComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectRouterComponent.prototype.render = function () {
        var _this = this;
        var perm = this.props.currentProject.status === 'FETCHED' &&
            this.props.currentProject.project.perm
            ? this.props.currentProject.project.perm
            : 0x00;
        var lsb = perm & acl.FEATURE_MASK;
        var baseUrl = this.props.match.path;
        var url = this.props.match.url;
        var currentProject = this.props.currentProject;
        var rootFolder = this.props.currentProject.root;
        var routerProps = this.props;
        if (currentProject.status === 'FETCHED' &&
            this.props.match.params.projectId ===
                currentProject.project.id.toString() &&
            this.props.metadata) {
            return (React.createElement(React.Fragment, null,
                React.createElement(ShoppingCart_1.default, { feature: 'filestab', baseUrl: url, rootFolder: currentProject.project.rootFolder, projectId: currentProject.project.id, featurePerm: currentProject.project.perm }),
                React.createElement(react_router_dom_1.Switch, { key: 'routes' },
                    perm & acl.FILESTAB_PERM && [
                        React.createElement(react_router_dom_1.Redirect, { exact: true, key: 'files', from: baseUrl + "/files/", to: "/".concat(this.props.selectedLanguage, "/projects/").concat(currentProject.project.id, "/files/").concat(currentProject.project.rootFolder) }),
                        React.createElement(react_router_dom_1.Route, { key: 'files', path: baseUrl + "/files/:folderId", render: function (props) { return (React.createElement(FilesRouter_1.default, __assign({}, props, { BreadCrumb: FilesBreadCrumb, Tools: Tools_1.default, ViewHeader: ViewHeader_1.ViewHeader, ListHeader: ListHeader_1.ListHeader, ListRow: ListRow_1.ListRow, metadata: _this.props.metadata, toggleUploadModal: routerProps.toggleUploadModal, appendUploadFiles: routerProps.appendUploadFiles, selectedLanguage: _this.props.selectedLanguage, rootFolder: currentProject.root, currentProject: currentProject.project, showFolderTree: true }))); } })
                    ],
                    perm & acl.ORDER_PERM && (React.createElement(react_router_dom_1.Route, { exact: true, key: 'distribution', path: baseUrl + "/distribution", render: function () {
                            return rootFolder ? (React.createElement(DistributionView_1.default, { currentProject: currentProject.project, currentFolder: rootFolder })) : null;
                        } })),
                    (perm & acl.ORDER_PERM) > 0 && (React.createElement(react_router_dom_1.Route, { key: 'orders', path: baseUrl + "/orders", render: function (props) {
                            return rootFolder ? (React.createElement(ordersRouter_1.default, __assign({}, props, { currentFolder: rootFolder, currentProject: currentProject.project, metadata: _this.props.metadata }))) : null;
                        } })),
                    (perm & acl.AUTOMATIC_ORDER_PERM) > 0 && (React.createElement(react_router_dom_1.Route, { key: 'automatic-orders', path: baseUrl + "/automatic-orders", render: function (props) {
                            return rootFolder ? (React.createElement(automaticOrdersRouter_1.default, __assign({}, props, { currentFolder: rootFolder, currentProject: currentProject.project, metadata: _this.props.metadata }))) : null;
                        } })),
                    perm & (acl.PROJECT_ADMIN_GRANT & ~acl.FEATURE_MASK) &&
                        (lsb ? (perm & acl.CONGRID_PERM) === acl.CONGRID_PERM : 0) && [
                        React.createElement(react_router_dom_1.Route, { exact: true, key: 'congrid-view', path: baseUrl + "/congrid/", render: function (props) { return (React.createElement(CongridView_1.default, __assign({}, props, { currentProject: currentProject.project }))); } }),
                        React.createElement(react_router_dom_1.Route, { exact: true, key: 'congrid-link', path: baseUrl + "/congrid/:id/link", render: function (props) { return (React.createElement(CongridLinkWizard_1.default, __assign({}, props, { currentProject: currentProject.project }))); } })
                    ],
                    aclUtils.hasVektorioPerm(perm) && (React.createElement(react_router_dom_1.Route, { key: 'vektorio-view', path: "".concat(baseUrl, "/vektorio/"), render: function (props) { return (React.createElement(VektorioView_1.default, __assign({}, props, { currentProject: currentProject.project, selectedLanguage: routerProps.selectedLanguage }))); } })),
                    (lsb ? (perm & acl.SOKOBID_PERM) === acl.SOKOBID_PERM : 0) && (React.createElement(react_router_dom_1.Route, { exact: true, key: 'briefcases', path: baseUrl + '/briefcases', render: function (props) { return (React.createElement(BriefcaseListView_1.default, __assign({}, props, { currentProject: currentProject.project }))); } })),
                    (perm & (acl.WORKSITE_DIARY_MASTER_GRANT & ~acl.FEATURE_MASK) ||
                        perm &
                            (acl.WORKSITE_DIARY_SUPERVISOR_GRANT & ~acl.FEATURE_MASK) ||
                        perm & (acl.WORKSITE_DIARY_USER_GRANT & ~acl.FEATURE_MASK) ||
                        perm & (acl.TRMVRMETER_EMPLOYER_GRANT & ~acl.FEATURE_MASK) ||
                        perm & (acl.TRMVRMETER_EMPLOYEE_GRANT & ~acl.FEATURE_MASK) ||
                        perm & (acl.TRMVRMETER_PREVIEW_GRANT & ~acl.FEATURE_MASK)) &&
                        (lsb
                            ? (perm & acl.SOKOSITE_PERM) === acl.SOKOSITE_PERM
                            : 0) && (React.createElement(react_router_dom_1.Route, { key: 'sokosite-pages', path: baseUrl + '/sokosite', render: function (props) { return (React.createElement(sokoSiteRouter_1.default, __assign({}, props, { currentProject: currentProject.project, toggleUploadModal: routerProps.toggleUploadModal, appendUploadFiles: routerProps.appendUploadFiles, selectedLanguage: routerProps.selectedLanguage }))); } })),
                    React.createElement(react_router_dom_1.Route, { exact: true, key: 'home', path: baseUrl + '/', render: function (props) { return (React.createElement(ProjectHomeView_1.default, __assign({}, props, { currentProject: currentProject.project }))); } }),
                    adminRoutes(baseUrl, this.props.user, currentProject, perm),
                    (perm &
                        ~acl.FEATURE_MASK &
                        (acl.PROJECT_ADMIN_GRANT |
                            acl.LIGHT_ADMIN_GRANT |
                            acl.SOKOBID_ADMIN_GRANT) ||
                        currentProject.project.showPartiesTab) && (React.createElement(react_router_dom_1.Route, { exact: true, key: 'teammembers', path: baseUrl + "/teammembers", render: function (props) { return (React.createElement(ProjectTeamMembersView_1.default, __assign({}, props, { currentProject: currentProject.project }))); } })),
                    React.createElement(react_router_dom_1.Redirect, { key: 'redirect', to: "/".concat((0, translate_1.getLanguage)(), "/projects/").concat(currentProject.project.id) }))));
        }
        else if (currentProject.status === 'ERROR') {
            return (React.createElement("div", { className: "project-router-error" },
                React.createElement("div", null,
                    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_19'), width: 200, height: 200 })),
                React.createElement("h3", null, (0, translation_1.getLocalization)('router/project/error/unableFetchProject')),
                React.createElement("span", null,
                    React.createElement(sok_ui_1.Button, { color: 'base-blue', onClick: function () {
                            return _this.props.onFetchProject(parseInt(_this.props.match.params.projectId, 10));
                        } }, (0, translation_1.getLocalization)('global/tryAgain')))));
        }
        else {
            return (React.createElement("div", { className: 'content-wrapper-content' },
                React.createElement("div", { className: 'project-router-loading-view' },
                    React.createElement("main", { className: 'content' },
                        React.createElement("div", { className: "project-router-loading" },
                            React.createElement(sok_ui_1.LoadingSpinner, null))))));
        }
    };
    return ProjectRouterComponent;
}(React.PureComponent)));
exports.default = exports.ProjectRouter;
